<template>
  <div class="card mgt-20px">
    <header class="header-card">
      <p>
        {{ $t('piecesJointes.attachments')}}
      </p>
    </header>
    <div class="card-content">
      <app-pieces-jointes readOnly
                          deletable
                          autoSave
                          :checkPermissions=checkPermissions(constantes.REMISES_BANCAIRES.maj)
      />
    </div>
  </div>
</template>

<script>

import { createNamespacedHelpers } from 'vuex';
import PiecesJointes from '@/components/general/piecesJointes';
import { REMISES_BANCAIRES } from '@/configuration/permissionsBodacConf';
import messageErreur from '@/services/general/messageErreur';

const Attachments = createNamespacedHelpers('attachments');
const Permissions = createNamespacedHelpers('permissions');

export default {
  props: {
    remiseBancaire: {
      type: Object,
      required: true,
    },
  },
  data() {
    return {
      constantes: {
        REMISES_BANCAIRES,
      },
    };
  },
  components: {
    appPiecesJointes: PiecesJointes,
  },
  computed: {
    ...Permissions.mapGetters({
      checkPermissions: 'checkPermissions',
    }),
  },
  methods: {
    ...Attachments.mapActions({
      showAddAttachmentModal: 'showAddModal',
      setAttachmentContext: 'setContext',
      setAttachmentElementId: 'setElementId',
      loadAttachments: 'loadAttachments',
    }),
    async updateAttachement() {
      const loadingComponent = this.$buefy.loading.open();
      try {
        await this.loadAttachments();
        loadingComponent.close();
      } catch (e) {
        loadingComponent.close();
        messageErreur(this.$i18n);
        throw e;
      }
    },
  },
  async mounted() {
    const loadingComponent = this.$buefy.loading.open();
    try {
      await this.setAttachmentContext({ module: 'remiseBancaire' });
      await this.setAttachmentElementId({ id: this.remiseBancaire.id });
      loadingComponent.close();
    } catch (e) {
      loadingComponent.close();
      messageErreur(this.$i18n);
      throw e;
    }
  },
};

</script>
